import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SEO } from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from './messages';

export const Route = createFileRoute('/auth/reset-two-factor')({
  component: ResetTwoFactorView,
});

function ResetTwoFactorView() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const reset2FAMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={reset2FAMessages.title}
        description={reset2FAMessages.description}
        keywords={reset2FAMessages.keywords}
        page="reset-two-factor"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full overflow-auto lg:overflow-visible">
        <div className="max-w-3xl mx-auto">
          <div className="justify-center lg:px-8 sm:px-6 py-12">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
